import { Modal, ModalFooter } from '@/src/components/Antd';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import TextArea from '@/src/components/Antd/TextArea/TextArea';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import React, { useMemo, useState } from 'react';
import { SizeFittingTable } from 'src/components/Antd';
import StockDisplay from '../../Components/PreviewStock/PreviewStock';
import { EType } from '../../type';
import BtnInput from '../BtnInput';
import css from './css.less';

import _ from 'lodash';
import { MidTitle } from 'src/components/EditableTable/EditableTable';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { getExactProduct } from 'src/request/product/product';
import { i18nGet } from 'src/tools/tools';
import { InventoryProduct } from '../../type';
interface IProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (uuid, inventoryUuid, type, value, notes) => void;
  productSet: InventoryProduct;
  afterClose: () => void;
  maskClosable: boolean;
  warehouseUuid?: string;
}
const SetAdjustion = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    visible,
    onCancel,
    onOk,
    productSet: product,
    warehouseUuid,
    ...rest
  } = props;
  const { uuid, available } = product;

  const [productSet, setProductSet] = useState<InventoryProduct>();
  const [loaded, setLoaded] = React.useState(false);
  const [notes, setNotes] = useState();
  const [value, setValue] = useState<number>();
  const [type, setType] = useState('Add');
  const [valueErr, setValueErr] = useState(false);
  const [hasModified, setHasModified] = useState(false);
  React.useEffect(() => {
    getExactProduct(warehouseUuid, uuid).then((p: any) => {
      //console.log(p);
      const { inventoryUuid, available } = product;
      // const items = p.productSet.items;
      const items = _.get(p, 'productSet.items', []);
      const itemsWithUuid = items.map((i) => {
        //console.log(i);
        const uuid = _.get(i, 'product.uuid');
        return { ...i, uuid };
      });
      const convertedProductSet = { items: itemsWithUuid };
      setProductSet({
        ...p,
        inventoryUuid,
        available,
        productSet: convertedProductSet,
      });
      setLoaded(true);
    });
  }, []);

  const setMin = useMemo(() => {
    const { available, productSet: { items: productItems = [] } = {} } =
      productSet || {};
    const allAmount = productItems.map((item) => {
      const {
        noOfUnit,
        product: { stockAvailable = 0 },
      } = item;
      return Math.floor(stockAvailable / noOfUnit);
    });
    const min = _.min(allAmount); //还可以再加几件
    return min + available;
  }, [productSet]);
  // const maxiumSetAmount = useMemo(() => {
  const displayError = React.useMemo(() => {
    if (type === 'Add') {
      if (available + value > setMin) {
        return true;
      }
      return false;
    }
    if (type === 'Set') {
      if (value > setMin) {
        return true;
      }
      return false;
    }
    return false;
  }, [value, type, setMin]);
  const checkData = () => {
    const { uuid = '', inventoryUuid = '' } = productSet || {};
    if (!value && value !== 0) {
      setValueErr(true);
      return false;
    }
    if (displayError) {
      return false;
    }
    onOk(uuid, inventoryUuid, type, value, notes);
  };
  const btns = React.useMemo(() => {
    return [
      {
        onClick: () => {
          setType('Add');
        },
        value: EType.Add,
        text: getI18n('general.linkModule.Modal.add'),
      },
      {
        onClick: () => {
          setType('Set');
        },
        value: EType.Set,
        text: getI18n('general.set.set'),
      },
    ];
  }, [type]);

  const onChange = (data) => {
    setValue(data);
    setValueErr(false);
    setHasModified(true);
  };
  const setColumns = [
    {
      title: getI18n('general.set.set'),
      dataIndex: 'sku',
      className: css.columnClass,
      key: 'sku',
      default: true,
      optional: false,
      minWidth: 132,
    },
    {
      title: '',
      dataIndex: 'name',
      className: css.columnClass,
      key: 'name',
      default: true,
      optional: false,
      minWidth: 186,
    },
    {
      title: getI18n(
        'inventory.inventory.list_components_SetAdjustion_Quantity',
      ),
      dataIndex: 'stockQuantity',
      className: css.columnClass,
      key: 'stockQuantity',
      default: true,
      optional: false,
      minWidth: 136,
      childGenerate: (text, record, index) => {
        const { available } = record;
        return (
          <NoWrapContainer>
            <StockDisplay type={type} value={value} stock={available} />
          </NoWrapContainer>
        );
      },
    },
    {
      title: '',
      dataIndex: 'value',
      className: css.columnClass,
      key: 'value',
      default: true,
      optional: false,
      width: 187,
      childGenerate: (text, record, index) => {
        return (
          <div className={displayError ? css.error : css.noErr}>
            <BtnInput
              btnValue={type}
              inputValue={value}
              inputOnChange={onChange}
              inputValueError={valueErr}
              btns={btns}
            />
          </div>
        );
      },
    },
  ];
  const includesColumns = [
    {
      title: getI18n(
        'inventory.inventory.list_components_SetAdjustion_setIncludes',
      ),

      className: css.columnClass,
      key: 'sku',
      default: true,
      optional: false,
      minWidth: 132,
      childGenerate: (text, record) => {
        const { product } = record;
        const { sku } = product;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={sku}>{sku}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      title: '',
      dataIndex: 'name',
      className: css.columnClass,

      default: true,
      optional: false,
      minWidth: 186,
      childGenerate: (text, record) => {
        const { product } = record;
        const { name } = product;
        return (
          <GlobalTooltip title={name}>
            <div className={css.nameColumn}>{name}</div>
          </GlobalTooltip>
        );
      },
    },
    {
      title: getI18n(
        'inventory.inventory.list_components_SetAdjustion_atyInSet',
      ),
      dataIndex: 'noOfUnit',
      className: css.columnClass,
      key: 'noOfUnit',
      default: true,
      optional: false,
      minWidth: 130,
    },
    {
      title: getI18n(
        'inventory.inventory.list_components_SetAdjustion_Available',
      ),
      className: css.columnClass,
      key: 'value',
      default: true,
      optional: false,
      sorter: (a, b) => {
        const { product: productA } = a;
        const { stockAvailable: stockAvailableA } = productA;
        const { product: productB } = b;
        const { stockAvailable: stockAvailableB } = productB;
        return stockAvailableA - stockAvailableB;
      },
      childGenerate: (text, record) => {
        const { product } = record;
        const { stockAvailable } = product;
        return (
          <NoWrapContainer>
            <MidTitle>
              <GlobalTooltip title={stockAvailable}>
                {stockAvailable}
              </GlobalTooltip>
            </MidTitle>
          </NoWrapContainer>
        );
      },
      minWidth: 100,
    },
    {
      title: getI18n('general.stock'),
      dataIndex: 'stock',
      className: css.columnClass,
      key: 'stock',
      default: true,
      optional: false,
      align: 'center',
      childGenerate: (text, record) => {
        const { product } = record;
        const { stockQuantity } = product;
        return (
          <NoWrapContainer>
            <MidTitle>
              <GlobalTooltip title={stockQuantity}>
                {stockQuantity}
              </GlobalTooltip>
            </MidTitle>
          </NoWrapContainer>
        );
      },
      sorter: (a, b) => {
        const { product: productA } = a;
        const { stockQuantity: stockQuantityA } = productA;
        const { product: productB } = b;
        const { stockQuantity: stockQuantityB } = productB;
        return stockQuantityA - stockQuantityB;
      },
      minWidth: 100,
    },
  ];
  return (
    <Modal
      title={getI18n(
        'inventory.inventory.list_components_SetAdjustion_product_set',
      )}
      visible={visible}
      width={700}
      onCancel={onCancel}
      className={css.body}
      {...rest}>
      {loaded && (
        <React.Fragment>
          <div className={css.setTable}>
            <SizeFittingTable
              rowKey='uuid'
              pagination={false}
              id='SetInventoryAdjust'
              columns={setColumns}
              dataSource={[productSet]}
              rowSelection={false}
            />
            {displayError && (
              <div className={css.valueErr}>
                {getI18n(
                  'inventory.inventory.list_components_SetAdjustion_limit',
                )}
              </div>
            )}
            {hasModified && (
              <div className={css.valueTip}>
                {getI18n(
                  'inventory.inventory.list_components_SetAdjustion_editing',
                )}
              </div>
            )}
          </div>
          <div className={css.table}>
            <SizeFittingTable
              rowKey='uuid'
              pagination={false}
              id='SetInventoryAdjustBottom'
              columns={includesColumns}
              dataSource={productSet.productSet.items || []}
              rowSelection={false}
            />
          </div>
          <div>
            <Row
              elements={[
                {
                  child: (
                    <React.Fragment>
                      <TopContainer className={css.notesTopContainer}>
                        <ItemWrapper
                          title={getI18n(
                            'inventory.inventory.detail_general_Notes',
                          )}
                          rightPart={
                            <CountWords
                              count={(notes || '').length}
                              allCount={500}
                            />
                          }>
                          <TextArea
                            autoSize={{ minRows: 1, maxRows: 5 }}
                            size='large'
                            maxLength={500}
                            placeholder={getI18n(
                              'inventory.inventory.enternotes',
                            )}
                            value={notes}
                            onChange={(e) => setNotes(e)}
                          />
                        </ItemWrapper>
                      </TopContainer>
                    </React.Fragment>
                  ),
                },
              ]}
            />
          </div>
        </React.Fragment>
      )}

      <ModalFooter
        okText={getI18n('general.save')}
        cancelText={getI18n('general.cancel')}
        okClassName={css.okBtn}
        onOk={checkData}
        onCancel={onCancel}
      />
    </Modal>
  );
};
export default SetAdjustion;
